import SelectedPeriodTag from './SelectedPeriodTag';

export default SelectedPeriodTag;
